import { gql } from "@apollo/client";

export const CREATE_EPISODE_MUTATION = gql(`
  mutation CreateEpisode(
    $patientId: Int!,
    $serviceLineId: Int!,
    $organizationalUnitId: Int,
    $autoschedulerGroup: Int,
    $careRequirements: [CareRequirementInput!],
    $precautionIds: [Int!]
  )
  @permission(requires: managePatients, check: [userInServiceLine])
  {
    createEpisode(
      patientId: $patientId,
      serviceLineId: $serviceLineId,
      organizationalUnitId: $organizationalUnitId,
      autoschedulerGroup: $autoschedulerGroup,
      careRequirements: $careRequirements,
      precautionIds: $precautionIds,
    ) {
      id
      active
      serviceLineId
      organizationalUnitId
      updatedAt
    }
  }
`);

export const GET_EPISODE_CARE_REQUIREMENTS_QUERY = gql(`
  query GetEpisodeCareRequirements($episodeId: Int!)
  @permission(requires: managePatients)
  {
    episodeSingle(where: { id: { eq: $episodeId } }) {
      id
      autoschedulerGroup
      organizationalUnitId
    }
    careRequirement(
      where: { episodeId: { eq: $episodeId } }
      orderBy: { id: { direction: asc, priority: 1 } }
    ) {
      id
      episodeId
      visitTypeId
      duration
      rruleFreq
      rruleDtstart
      rruleUntil
      rruleInterval
      rruleByweekday
      earliestStartTime
      latestStartTime
      minTimeFromLastVisit
      maxTimeFromLastVisit
      dayOfAdmission
      services {
        id
        serviceId
        deleted
        service {
          id
          name
        }
      }
    }
    # Any visit that has progressed past scheduled/canceled means the episode has
    # been "acted on" — used to lock the Day-of-Admission section. Mirrors the
    # backend's includeToday check (apps/service/services/episode.ts).
    visit(
      where: { episodeId: { eq: $episodeId }, eventStatus: { notInArray: [scheduled, canceled] } }
      limit: 1
    ) {
      id
    }
  }
`);

export const UPDATE_EPISODE_MUTATION = gql(`
  mutation UpdateEpisode(
    $episodeId: Int!,
    $organizationalUnitId: Int,
    $active: Boolean,
    $autoschedulerGroup: Int,
    $careRequirements: [CareRequirementUpsertInput!],
    $precautionIds: [Int!],
  )
  @permission(requires: managePatients, check: [userInEpisodeServiceLine])
  {
    updateEpisode(
      id: $episodeId,
      organizationalUnitId: $organizationalUnitId,
      active: $active,
      autoschedulerGroup: $autoschedulerGroup,
      careRequirements: $careRequirements,
      precautionIds: $precautionIds,
    ) {
      id
      active
      serviceLineId
      organizationalUnitId
      updatedAt
      precautions {
        id
        precautionId
      }
    }
  }
`);
